module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cuadro-container"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('info-card', {
    attrs: {
      "title": _vm.o.titulo,
      "number": _vm.o.cantidad,
      "iconClass": _vm.o.iconClass
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb3bceca","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/c_kpi_cantidad_mis_boletas_sin_visualizar.vue
// module id = 948
// module chunks = 0